import React, { Component } from 'react';
import Button from '../../artzu-ui/src/Button'
import Card from "../../artzu-ui/src/Card"
import Loading from '../shared/Loading'
import { Mutation } from 'react-apollo'
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faCheckCircle, faEllipsisH } from '@fortawesome/pro-light-svg-icons';
import gql from 'graphql-tag'
// import './profile.css';

class ChargeCard extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  render() {
    const { amount, source, showProcessing, processing, handlePayment, showPaymentError, paymentErrorMsg, onClick, checkoutSuccess, history, holder } = this.props;
    return (
      <Mutation
        mutation={CHARGE_SOURCE}
        onCompleted={async ({ chargeSource }) => {
          handlePayment(chargeSource)
        }}
      >
        {chargeSource => (
          processing ? <Loading size="5x" /> :
          showPaymentError ? 
          <div className="checkout-response-page">
            <FontAwesomeIcon icon={faExclamationCircle} size="10x" color="#FF5757" style={{ marginBottom: "24px" }} />
            <p>The following errors have occured: </p>
            <p>{paymentErrorMsg}</p>
            <div className="balance-footer">
              <Button
                className="balance-button"
                padding="0"
                label="Back"
                color="#414141"
                fullWidth={true}
                onClick={onClick}
              />
            </div>
          </div> :
          checkoutSuccess ? 
          <div className="checkout-response-page">
            <FontAwesomeIcon icon={faCheckCircle} size="10x" color="#128dff" style={{ marginBottom: "24px" }} />
            <p className="response-msg">Your transaction was successfully processed!</p>
            <p>Outstanding Balance</p>
            <h2>${amount}</h2>
              <div className={`balance-footer${window.innerWidth >= 768 ? "-desktop" : ""}`}>
              <Button
                className="balance-button"
                padding="0"
                label="Dashboard"
                color="#414141"
                fullWidth={true}
                onClick={() => history.push("/dashboard")}
              />
            </div>
          </div> :
          <div className="checkout-page">
            <div className="checkout-top-msg">
              <p>Please confirm the details: </p>
            </div>
            <div className="card-preview">
              <p>Payment Method</p>
              <Card
                className="cc-card"
                style={styles.slide1}
                padding="1em"
              >
                <div className="card-display">
                  <div className="card-options--hidden">
                    <FontAwesomeIcon icon={faEllipsisH} onClick={() => this.setState({ removingCard: true })} style={{ color: "#414141", backgroundColor: "white", borderRadius: "50%", width: "20px", height: "20px" }} />
                  </div>
                  <div className="default-card">{source.primary ? "Primary Card" : "Secondary Card"}</div>
                  <p className="card-field-label">Card Holder Name</p>
                  <div className="card-field-content">{source.owner.name}</div>
                  <div className="space-between">
                    <div className="column-flex">
                      <span className="card-field-label">Card Number</span>
                      <span className="card-field-content">**** **** **** {source.card.last4}</span>
                    </div>
                    <div className="column-flex">
                      <span className="card-field-label">Expiry Date</span>
                      <span className="card-field-content">{source.card.expMonth}/{source.card.expYear}</span>
                    </div>
                  </div>
                  <div className="bottom-filler">{source.primary ? "Automatic Payment Permitted" : ""}</div>
                </div>
              </Card>
            </div>
            <div className="payment-amount">
              <p>Payment Amount</p>
              <h2>${amount}</h2>
            </div>
              <div className={`balance-footer${window.innerWidth >= 768 ? "-desktop" : ""}`}>
              {window.innerWidth >= 768 ?
                <Button
                  className="balance-button"
                  padding="0"
                  label="Cancel"
                  color="#414141"
                  onClick={onClick}
                /> : null}
              <Button
                className="balance-button"
                padding="0"
                label="Pay"
                primary
                fullWidth={window.innerWidth < 768}
                onClick={() => {
                  showProcessing()
                  chargeSource({ variables: {sourceId: source.id, amount: parseFloat(amount)} })
                }}
              />
            </div>
          </div>
        )}
      </Mutation>
    );
  }
}

const CHARGE_SOURCE = gql`
  mutation ChargeSource($sourceId: String!, $amount: Float!) {
    chargeSource(sourceId: $sourceId, amount: $amount) {
      transaction {
        amount
      }
      currentBalance
      errors
    }
  }
`;

const styles = {
  slide1: {
    width: '72vw',
    maxWidth: '337px',
    height: '45vw',
    maxHeight: '213px',
    color: '#fff',
    borderRadius: '12px',
    borderColor: '#414141',
    backgroundColor: '#414141',
    display: 'flex',
    flexDirection: 'column'
  },
};

export default ChargeCard;



// WEBPACK FOOTER //
// ./src/components/NewPayments/ChargeCard.js